import { useCallback, useEffect, useState } from 'react';
import { getToken } from '../utils';
import { LiaTimesSolid } from 'react-icons/lia';
import { BankAccountDetails } from './BankAccountDetails';

function PaymentOptions({ data }) {
  const userId = getToken()?.user?.id;
  const [paymentMode, setPaymentMode] = useState('bank');
  const [interswitchUrl, setInterSwitchUrl] = useState('');

  const {
    handleHideBankDetails,
    bidChatAccepted,
    viewData,
    handleOpenandCloseModal,
    handleToast,
    file,
    setFile,
    input,
    setInput,
    handleSubmitPayment,
    isSubmittingPayment,
    paymentDetails,
    setPaymentDetails,
    openModal,
    handleFileChange,
    selectedFiles,
  } = data;

  const transationId = viewData?.id;
  const paymentId = paymentDetails?.id;
  const amount = paymentDetails?.total;
  const currencyId = paymentDetails?.cx_account?.currency?.id;

  const handlePayment = useCallback(() => {
    const url = `https://apex.loyaltyview.com/online-payment?payment_gateway_id=${1}&amount=${amount}&type_id=${2}&cx_id=${transationId}&payment_id=${paymentId}&subscription_id=${0}&currency_id=${currencyId}&user_id=${userId}`;
    
    // Open the URL in a new window
    window.open(url, '_blank');
    
    // Optionally, you can set state or perform other actions here if needed
    setInterSwitchUrl(url);
    setPaymentMode('online');
  }, [amount, currencyId, paymentId, transationId, userId]);

  useEffect(() => {
    if (paymentMode === 'online') {
      handlePayment();
    }
  }, [handlePayment, paymentMode]);

  return (
    <article className='flex flex-col md:flex-row items-left py-8 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 mx-auto shadow-lg rounded bg-p-wh w-full md:w-[80%] gap-4 px-6 h-[30rem] overflow-hidden'>
      <div className='flex flex-col items-start [&>*]:px-8 gap-6 flex-[40%] shadow-sm'>
        <span
          className='absolute items-center top-[10px] right-[6px] text-2xl text-s-bk cursor-pointer hover:text-p-bk'
          onClick={() => handleOpenandCloseModal('close')}
        >
          <LiaTimesSolid />
        </span>
        <h2 className='text-p-bk text-base font-normal leading-[32px] uppercase pb-4 border-b-[0.4px] border-b-[#D0D1D2] w-full'>
          Select a payment option
        </h2>

        <button
          className={`w-full text-p-bk text-base font-normal leading-[32px] text-left py-1.5 flex items-center gap-2 ${
            paymentMode === 'bank' ? 'bg-b-mc text-white' : ''
          }`}
          onClick={() => setPaymentMode('bank')}
        >
          <i>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M8.65086 7.58625C11.803 7.58625 14.3584 6.70649 14.3584 5.62125C14.3584 4.53601 11.803 3.65625 8.65086 3.65625C5.49869 3.65625 2.94336 4.53601 2.94336 5.62125C2.94336 6.70649 5.49869 7.58625 8.65086 7.58625Z'
                fill='#D0D1D2'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M14.3621 8.17505C14.3621 9.2588 11.8046 10.14 8.65086 10.14C5.49711 10.14 2.94336 9.2588 2.94336 8.17505'
                fill='#D0D1D2'
              />
              <path
                d='M14.3621 8.17505C14.3621 9.2588 11.8046 10.14 8.65086 10.14C5.49711 10.14 2.94336 9.2588 2.94336 8.17505'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M10.2671 12.5363C10.1171 12.5363 8.80461 12.5363 8.65086 12.5363C5.49711 12.5363 2.94336 11.655 2.94336 10.5713'
                fill='#D0D1D2'
              />
              <path
                d='M10.2671 12.5363C10.1171 12.5363 8.80461 12.5363 8.65086 12.5363C5.49711 12.5363 2.94336 11.655 2.94336 10.5713'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M9.34086 15C9.11586 15 8.88336 15 8.65086 15C5.49711 15 2.94336 14.1225 2.94336 13.035'
                fill='#D0D1D2'
              />
              <path
                d='M9.34086 15C9.11586 15 8.88336 15 8.65086 15C5.49711 15 2.94336 14.1225 2.94336 13.035'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M9.63711 17.4488C9.30923 17.478 8.97991 17.4881 8.65086 17.4788C5.49711 17.4788 2.94336 16.5975 2.94336 15.5138'
                fill='#D0D1D2'
              />
              <path
                d='M9.63711 17.4488C9.30923 17.478 8.97991 17.4881 8.65086 17.4788C5.49711 17.4788 2.94336 16.5975 2.94336 15.5138'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M2.94336 15.5325V5.62878'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M14.3623 11.2538V5.62125'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M15.3491 15.3975C18.5013 15.3975 21.0566 14.5178 21.0566 13.4325C21.0566 12.3473 18.5013 11.4675 15.3491 11.4675C12.1969 11.4675 9.6416 12.3473 9.6416 13.4325C9.6416 14.5178 12.1969 15.3975 15.3491 15.3975Z'
                fill='#D0D1D2'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M21.0564 15.9862C21.0564 17.0738 18.5027 17.9512 15.3489 17.9512C12.1952 17.9512 9.6377 17.0738 9.6377 15.9862'
                fill='#D0D1D2'
              />
              <path
                d='M21.0564 15.9862C21.0564 17.0737 18.5027 17.9512 15.3489 17.9512C12.1952 17.9512 9.6377 17.0737 9.6377 15.9862'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M21.0564 18.375C21.0564 19.4625 18.5027 20.3438 15.3489 20.3438C12.1952 20.3438 9.6377 19.4663 9.6377 18.375'
                fill='#D0D1D2'
              />
              <path
                d='M21.0564 18.375C21.0564 19.4625 18.5027 20.3438 15.3489 20.3438C12.1952 20.3438 9.6377 19.4663 9.6377 18.375'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M9.6377 18.345V13.1512'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M21.0566 18.4537V13.365'
                stroke='#2C2F30'
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </i>
          <span>Bank Transfer</span>
        </button>

        <button
          className={`w-full text-p-bk text-base font-normal leading-[32px] text-left py-1.5 flex items-center gap-2 ${
            paymentMode === 'online' ? 'bg-b-mc text-white' : ''
          }`}
          // onClick={() => setPaymentMode('online')}
          onClick={handlePayment}
        >
          <i>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='27'
              height='22'
              viewBox='0 0 27 22'
              fill='none'
            >
              <path
                d='M23.2222 1.27778H3.77778C2.24365 1.27778 1 2.52143 1 4.05556V17.9444C1 19.4786 2.24365 20.7222 3.77778 20.7222H23.2222C24.7563 20.7222 26 19.4786 26 17.9444V4.05556C26 2.52143 24.7563 1.27778 23.2222 1.27778Z'
                fill='currentColor'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path d='M1 8.22223H26H1Z' fill='currentColor' />
              <path
                d='M1 8.22223H26'
                stroke='transparent'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </i>
          <span>Online with card</span>
        </button>
      </div>
      <div className='flex-[60%] md:pr-8 h-[60vh] overflow-scroll py-6'>
        {paymentMode === 'online' && (
          <iframe
            src={interswitchUrl}
            width='100%'
            height='100%'
            title='Interswitch'
          ></iframe>
        )}

        {paymentMode === 'bank' && (
          <BankAccountDetails
            data={{
              handleHideBankDetails,
              bidChatAccepted,
              viewData,
              handleOpenandCloseModal,
              handleToast,
              file,
              setFile,
              input,
              setInput,
              handleSubmitPayment,
              isSubmittingPayment,
              paymentDetails,
              setPaymentDetails,
              openModal,
              handleFileChange,
              selectedFiles,
            }}
          />
        )}
      </div>
    </article>
  );
}

export default PaymentOptions;
